// When the DOM is ready,
$(function() {

	/**
	 * Cache selectors
	 */
	var body        = $('html, body'),
		menuSecondary = $('.menu-secondary'),
		menuToggle    = $('.menu-toggle'),
		modal         = $('.modal'),
		modalToggle   = $('.modal-toggle');

	/**
	 * Menus
	 */
	menuSecondary.addClass('is-hidden');

	menuToggle.on('click', function(e) {
		e.preventDefault();
		$this = $(this);

		var thisMenu = $this.next('.menu');

		// Toggle classes
		$(this).toggleClass('is-active');
		thisMenu.toggleClass('is-hidden');
		thisMenu.toggleClass('is-visible');
	});

	/**
	 * Vertical Sidebar Menu Accordions
	 */

	setTimeout(function() {
		
		// Cache selectors
		var menuVertical = $('.menu-vertical'),
				menuVerticalParentLinks = $('.menu-vertical > li > a'),
				menuVerticalChildLists = menuVertical.find('ul'),
				menuVerticalChildLinks = menuVerticalChildLists.find('a');

		// If child lists exist,
		if(menuVerticalChildLists.length > 0) {

			// Hide all child lists
			menuVerticalChildLists.hide();

			// When parent link is clicked,
			menuVerticalParentLinks.on('click', function() {

				// Cache selectors
				var $this = $(this);
				
				// Hide all child lists
				menuVerticalChildLists.hide();
				menuVerticalParentLinks.removeClass('is-current');
				
				// Remove all styles
				$this.parent().find('ul').find('a').removeClass('is-current');
				
				// Add current styles
				$this.addClass('is-current');
				
				// Show current child list
				$this.parent().find('ul').show();
				
				// Scroll back up
				$('html, body').scrollTop(0);

			});
			
			// When child link is clicked,
			menuVerticalChildLinks.on('click', function() {
				// Cache selectors
				var $this = $(this);

				// Remove all styles
				menuVerticalChildLinks.removeClass('is-current');
				
				// Add current styles
				$this.addClass('is-current');
				
				// Scroll back up
				$('html, body').scrollTop(0);

			});

		}

	}, 2000);

});



// WEBPACK FOOTER //
// ./src/assets/js/main.js